module.exports = __webpack_public_path__ + "bacon.svg?fc753865ce4e7e40b68a2f133b63974a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bacon.svg
// module id = 12
// module chunks = 0